import Request from "./request";
const Company = "/company";
const Team = "/company/teams";
const Partner = "/partner";
const Inquire = "/companyInquire";

export default {
  async getCompany(query) {
    return Request.get(Company, {
      pageSize: query.pageSize,
      current: query.current
    });
  },
  async getTeam(query) {
    return Request.get(Team, {
      pageSize: query.pageSize,
      current: query.current
    });
  },
  async getTeamId(id) {
    return Request.get(`${Team}/${id}`);
  },
  async getPartner(query) {
    return Request.get(Partner, {
      pageSize: query.pageSize,
      current: query.current
    });
  },
  async getInquire(query) {
    return Request.post(Inquire, {
      companyName: query.companyName,
      companyEmail: query.companyEmail,
      tel: query.tel,
      content: query.content,
      linkman: query.linkman
    });
  }
};
